module.exports = "/_next/static/images/CompanyMission-2x-1156f5e625a1352f094eb5e2226003da.jpg.webp";